import { render, staticRenderFns } from "./CorporateList.vue?vue&type=template&id=8a5189f2&"
import script from "./CorporateList.vue?vue&type=script&lang=js&"
export * from "./CorporateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports